import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { SmsCreditData, SmsCredit } from '../../../interfaces/masters/smscredit';
 
@Injectable()
export class SmsCreditApi {
  private readonly apiController: string = 'SmsCredit'; 

  constructor(private api: HttpService) { }

  getall(url: string, options?: any): Observable<any[]> { 
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  getby_id(url : string, options?: any): Observable<any> { 
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directGet(url,header);
  }

  add(url:string, data: SmsCredit):Observable<SmsCredit[]>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post( url, data, header);
  }

  update(url:string, data: SmsCredit):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.directPut( url, data, {headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.directGet(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  searchList(url: string, data:any, options?: any): Observable<any[]> { 
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
}
